import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDotComponent } from "./med-icon-dot.component";

@NgModule({
  declarations: [
    MedIconDotComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDotComponent,
  ],
})
export class MedIconDotModule { }
